<script>
import { mapGetters, mapState } from "vuex";

import { i18n, setLocale } from "@v2/shared/config";
import moment from "moment";
import { Websocket } from "@/helpers/websocket";
import apiUser from "@/api/user";
import apiNotification from "@v2/entities/notification";
import CartCountComponent from "@/components/Custom/CartCountComponent.vue";

export default {
  name: "NotAuthHeader",

  data() {
    return {
      isProfilePopupShown: false,
      isMenuOpen: false,
      isShowNotification: false,
      readAtNotifications: [],
      socket: new Websocket()
    };
  },

  components: {
    CartCountComponent
  },

  computed: {
    ...mapState("auth", ["user", "isLoggedIn"]),
    ...mapState("notification", [
      "summaryNotificationList",
      "companiesSummaryNotification",
      "eventsSummaryNotification",
      "countUnreadItems"
    ]),
    ...mapState("services", ["cart"]),
    ...mapGetters("event", [
      "isEventMontage",
      "isServiceShown",
      "isSpecialProject",
      "isPartTime",
      "isOrganizerAndMedia"
    ]),

    userName() {
      if (!this.user) {
        return;
      }

      return `${this.user.name} ${this.user.lastname || ""}`;
    },

    currentLocale() {
      return i18n.locale;
    },

    nextLocale() {
      switch (this.currentLocale) {
        case "ru":
          return "en";

        case "en":
          return "ru";
      }

      return "ru";
    },

    listNotification() {
      let list = [];

      if (this.summaryNotificationList && this.summaryNotificationList.length) {
        this.summaryNotificationList.forEach(el => {
          list.push({
            id: el.id,
            createdAt: el.created_at
              ? moment(el.created_at).format("DD.MM.YYYY")
              : null,
            isNew: el.read_at === null,
            title:
              i18n.locale === "en" ? el.data.message_eng : el.data.message_rus,
            disabled: false
          });
        });
      }

      return list;
    },
    showCart() {
      return (
        (this.$route.meta.cart || this.$route.name === "cart") &&
        this.isServiceShown
      );
    }
  },

  watch: {
    summaryNotificationList(val, valOld) {
      if (!!val && valOld === null && this.isLoggedIn) {
        this.$store.dispatch("notification/getSummaryNotification");
      }
    }
  },

  created() {
    this.connectWebsocket();
    if (!this.summaryNotificationList.length && this.isLoggedIn) {
      this.$store.dispatch("notification/getSummaryNotification");
    }
  },

  destroyed() {
    this.socket.disconnectUser(this.user.id);
  },

  methods: {
    hideProfilePopup() {
      this.isProfilePopupShown = false;
    },

    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen;
    },

    hideMenu() {
      this.isMenuOpen = false;
    },

    async changeLocale() {
      await apiUser.setLocale(this.nextLocale);
      setLocale(this.nextLocale);
    },

    toggleMenuNotification() {
      this.isShowNotification = !this.isShowNotification;

      if (this.isShowNotification) {
        const _this = this;

        setTimeout(function() {
          _this.setVisibleNotification();
        }, 10);
      }
    },

    async hideNotification() {
      if (this.readAtNotifications && this.readAtNotifications.length) {
        await this.setReadNotification();
        this.readAtNotifications = [];
      }

      this.isShowNotification = false;
    },

    scrollNotification() {
      this.setVisibleNotification();
    },

    setVisibleNotification() {
      const _this = this;
      const paramsListNotification = this.$refs.notificationList?.getBoundingClientRect();

      if (!paramsListNotification) return;

      const newListNotification =
        this.listNotification && this.listNotification.length
          ? this.listNotification.filter(el => !!el.isNew)
          : [];

      newListNotification.forEach(notification => {
        // Определяем находится/находилось ли уведомление в зоне видимости
        const notificationItem = this.$refs[`notification-${notification.id}`]
          ? this.$refs[`notification-${notification.id}`][0]
          : null;

        const paramsItemNotification = notificationItem
          ? notificationItem.getBoundingClientRect()
          : null;

        const isVisibleItem =
          paramsItemNotification &&
          paramsItemNotification.top + paramsItemNotification.height / 2 <=
            paramsListNotification.top + paramsListNotification.height;

        if (
          isVisibleItem &&
          !notification.disabled &&
          !!notification.isNew &&
          !_this.readAtNotifications.includes(notification.id)
        ) {
          _this.readAtNotifications.push(notification.id);
        }
      });
    },

    async setReadNotification() {
      if (!this.isLoggedIn) return;

      this.readAtNotifications.forEach(async notificationId => {
        await apiNotification.update(notificationId);
      });

      this.$store.dispatch("notification/getSummaryNotification");
    },

    connectWebsocket() {
      const id = this.user.id;
      this.socket.connectUser(id, data => {
        if (data.notification)
          this.$store.dispatch(
            "notification/addNewNotification",
            data.notification
          );
      });
    }
  }
};
</script>

<template>
  <header
    class="app-header"
    :class="{ 'app-header_open': isMenuOpen, 'app-header--cart': showCart }"
  >
    <div class="container app-header__container">
      <ul class="app-header__navigation">
        <li
          class="app-header__navigation-item app-header__navigation-item_logo"
        >
          <span @click="hideMenu">
            <router-link
              :to="{ name: 'home' }"
              class="app-header__navigation-item-link"
            >
              <template v-if="currentLocale === 'en'">
                <icon name="logo-en" class="svg-icon--logo" />
              </template>

              <template v-else>
                <icon name="logo-ru" class="svg-icon--logo" />
              </template>

              <icon name="logo-icon" />
            </router-link>
          </span>
        </li>

        <li class="app-header__navigation-item app-header__navigation-item_lk">
          <span @click="hideMenu">
            <router-link
              :to="{ name: 'home' }"
              class="app-header__navigation-item-link"
            >
              {{ $t("common.expoName") }}
            </router-link>
          </span>
        </li>

        <li
          class="app-header__navigation-item app-header__navigation-item_myevents"
        >
          <span @click="hideMenu">
            <router-link
              :to="{ name: 'home' }"
              class="app-header__navigation-item-link"
            >
              <icon name="list" width="16" height="12" />
              {{ $t("common.header.myExhibitions") }}
            </router-link>
          </span>
        </li>

        <li
          class="app-header__navigation-item app-header__navigation-item_menu"
        >
          <a
            @click.prevent="toggleMenu"
            class="app-header__navigation-item-link"
          >
            <icon name="menu-close" width="16" height="10" v-if="isMenuOpen" />
            <icon name="menu" width="16" height="10" v-else />
          </a>
        </li>
      </ul>

      <ul class="app-header__navigation">
        <li
          v-if="showCart"
          class="app-header__navigation-item app-header__navigation-item_cart"
        >
          <router-link :to="{ name: 'cart', params: { id: $route.params.id } }">
            <CartCountComponent />
          </router-link>
        </li>

        <li
          class="app-header__navigation-item app-header__navigation-item_support"
        >
          <span @click="hideMenu">
            <router-link
              :to="{ name: 'support' }"
              class="app-header__navigation-item-link"
            >
              <icon width="18px" height="18px" name="help" />
              {{ $t("common.header.support") }}
            </router-link>
          </span>
        </li>

        <li
          class="app-header__navigation-item app-header__navigation-item_profile"
        >
          <span @click="hideMenu">
            <a
              href="#"
              @click.prevent="isProfilePopupShown = !isProfilePopupShown"
              class="app-header__navigation-item-link"
              :class="{ _active: isProfilePopupShown }"
            >
              <icon name="profile" width="16px" height="16px" />
              <span>
                {{ userName }}
                <icon name="arrow-down" width="11px" height="7px" />
              </span>
            </a>
          </span>

          <ul
            class="app-header__navigation-item-popup"
            v-if="isProfilePopupShown || isMenuOpen"
            v-click-outside="hideProfilePopup"
          >
            <li class="app-header__navigation-item-popup-item">
              <span @click="hideMenu">
                <router-link
                  :to="{ name: 'profile' }"
                  class="app-header__navigation-item-popup-item-link"
                >
                  <span @click="hideProfilePopup">{{
                    $t("common.header.profileEdit")
                  }}</span>
                </router-link>
              </span>
            </li>
            <li class="app-header__navigation-item-popup-item">
              <span @click="hideMenu">
                <router-link
                  :to="{ name: 'logout' }"
                  class="app-header__navigation-item-popup-item-link"
                >
                  <span @click="hideProfilePopup">{{
                    $t("common.header.profileLogout")
                  }}</span>
                </router-link>
              </span>
            </li>
          </ul>
        </li>

        <li
          class="app-header__navigation-item app-header__navigation-item_notification"
        >
          <div
            class="icon-notification-header"
            v-click-outside="hideNotification"
            @click="toggleMenuNotification()"
          >
            <icon width="17px" height="18px" name="notification-small" />
            <span
              v-if="countUnreadItems"
              class="icon-notification-header__count"
            >
              {{ countUnreadItems }}
            </span>
          </div>

          <div
            v-if="isShowNotification"
            ref="notificationList"
            class="list-notification"
          >
            <div class="list-notification__header">
              <div class="list-notification__header-title">
                {{ $t("notification.notifications") }}
              </div>
              <div class="list-notification__header-right">
                <router-link
                  :to="{ name: 'notifications' }"
                  class="list-notification__header-btn-all"
                >
                  {{ $t("notification.showAll") }}
                </router-link>

                <router-link
                  :to="{ name: 'profile' }"
                  class="list-notification__header-settings"
                >
                  <icon width="19px" height="19px" name="settings" />
                </router-link>
              </div>
            </div>
            <simplebar
              class="list-notification__list"
              @scroll="scrollNotification()"
            >
              <span
                v-for="item in listNotification"
                :key="item.id"
                :ref="`notification-${item.id}`"
                class="list-notification__item"
                :class="{
                  new: item.isNew
                }"
              >
                <span class="list-notification__item-date">
                  {{ item.createdAt }}
                </span>
                <span v-if="item.isNew" class="list-notification__item-label"
                  >New</span
                >
                <span
                  class="list-notification__item-title"
                  v-html="item.title"
                ></span>
              </span>
            </simplebar>
          </div>
        </li>

        <li
          class="app-header__navigation-item app-header__navigation-item_lang"
        >
          <a
            href="#"
            class="app-header__navigation-item-link"
            @click.prevent="changeLocale(nextLocale)"
          >
            {{ nextLocale }}
          </a>
        </li>
        <li
          class="app-header__navigation-item app-header__navigation-item_menu"
        >
          <a
            @click.prevent="toggleMenu"
            class="app-header__navigation-item-link"
          >
            <icon name="menu-close" width="16" height="10" v-if="isMenuOpen" />
            <icon name="menu" width="16" height="10" v-else />
          </a>
        </li>
      </ul>
    </div>
  </header>
</template>

<style lang="scss" scoped>
@import "@v2/app/styles/mixins";
@import "@v2/app/styles/media";

.app-header {
  background: #005197;
  position: sticky;
  top: 0;
  z-index: 16;

  &--cart {
    @include respond-down(md) {
      &:not(.app-header_open) {
        .app-header__navigation {
          &:first-child {
            flex-shrink: 1;
            flex-grow: 0 !important;

            .app-header__navigation-item_menu {
              display: none;
            }
          }

          &:last-child {
            display: flex !important;
            justify-content: flex-end;
            flex-shrink: 0;
            flex-grow: 1;

            li:not(:first-child):not(:last-child) {
              display: none;
            }
          }

          &-item {
            &_myevents {
              display: none;
            }

            &_cart {
              margin-left: auto;
              margin-right: auto;
            }
          }
        }
      }
    }
  }

  // Desktop and Tablet
  // ==================
  &__container {
    display: flex;
    align-items: center;
    justify-content: space-between;

    height: 56px;
  }

  &__navigation {
    display: flex;
    align-items: center;

    height: 100%;

    list-style: none;

    margin: 0;
    padding: 0;

    &-item {
      letter-spacing: -0.13px;
      font-size: 14px;
      color: #7ca4c7;

      position: relative;

      &:hover {
        color: #fff;
      }

      &-link {
        color: inherit;
        text-decoration: none;

        display: flex;
        align-items: center;

        & svg {
          margin-right: 9px;
        }

        &._active {
          color: #fff;
        }
      }

      &_logo {
        position: relative;
        margin-right: 0;

        .svg-icon--logo,
        .svg-icon--logo-icon {
          display: none;
        }

        @include respond-up(md) {
          &::after {
            content: "";

            display: block;

            width: 2px;
            height: 16px;

            border-radius: 1px;
            background-color: #7ca4c7;

            position: absolute;
            right: -9px;
            top: 3px;
          }
        }

        @include respond-between(md, lg) {
          .svg-icon--logo-icon {
            width: 23px;
            height: 23px;

            display: block;
          }
        }

        @include respond-up(lg) {
          .svg-icon--logo {
            width: 138px;
            height: 28px;

            display: block;

            fill: #fff;
          }

          &::after {
            right: -9px;
            top: 6px;
          }
        }
      }

      &_lk {
        margin-left: 25px;
        margin-right: 52px;

        font-size: 12px;
        color: #fff;
      }

      &_myevents &-link {
        color: #fff;
      }

      &_cart {
        margin-right: 22px;

        a {
          text-decoration: none;
        }
      }

      &_profile {
        margin-left: 32px;

        .svg-icon--arrow-down {
          margin-left: 3px;
        }
      }

      &_notification {
        margin-left: 20px;
      }

      &_lang {
        margin-right: 1px;
        margin-left: 20px;

        text-transform: capitalize;
      }

      &-popup {
        position: absolute;
        top: 50px;

        width: 252px;
        box-shadow: 0 5px 10px 0 rgba(0, 0, 0, 0.1);
        background-color: #ffffff;

        box-sizing: border-box;

        list-style: none;

        margin: 0;
        padding: 16px 25px 20px 25px;

        z-index: 2;

        &-item {
          &:not(:last-child) {
            margin-bottom: 15px;
          }

          &-link {
            @include hyperlink();
          }
        }
      }
    }
  }

  // Mobile
  // ==================

  @include respond-up(md) {
    &__navigation-item_menu {
      display: none;
    }
  }

  @include respond-down(md) {
    // CLOSE STATE
    &:not(&_open) &__navigation {
      &:first-child {
        flex-shrink: 0;
        flex-grow: 1;
      }

      &:last-child {
        display: none;
      }

      &-item {
        &_lk {
          display: none;
        }

        &_logo {
          .svg-icon--logo-icon {
            width: 23px;
            height: 23px;

            display: block;
          }
        }

        &_myevents {
          margin-left: auto;
          margin-right: auto;
        }
      }
    }

    // OPEN STATE

    &_open &__container {
      display: block;
      height: 100vh;
      margin-left: 0;
      margin-right: 0;
      width: 100%;
    }

    &_open &__navigation {
      height: auto;

      display: block;

      &-item {
        margin-right: 0;
        margin-left: 40px;
        margin-bottom: 32px;

        &-link {
          display: inline-flex;
        }

        &_logo {
          margin-top: 15px;
          margin-left: 16px;
          margin-bottom: 0;

          height: 35px;

          .svg-icon--logo {
            display: block;

            width: 141px;
            height: 40px;
          }
        }

        &_lk {
          font-size: 10px;

          padding-left: 41px;
          padding-bottom: 25px;

          margin-left: 0;
          margin-bottom: 30px;

          border-bottom: 1px solid rgba(#7ca4c7, 0.7);
        }

        &_menu {
          position: absolute;
          right: 18px;
          top: 23px;
        }

        &_profile {
          .svg-icon--arrow-down {
            display: none;
          }
        }

        &-popup {
          box-shadow: none;
          background: none;

          position: static;

          &-item-link {
            color: #6696c0;
            text-decoration: none;
            border: none;
          }
        }
      }
    }
  }
}

.icon-notification-header {
  display: inline-block;
  vertical-align: middle;
  position: relative;
  width: 17px;
  height: 18px;
  cursor: pointer;

  &__count {
    display: block;
    position: absolute;
    top: -4px;
    right: -6px;
    min-width: 15px;
    height: 15px;
    padding: 0 2px;
    font-weight: bold;
    font-size: 10px;
    line-height: 15px;
    text-align: center;
    border-radius: 15px;
    color: #ffffff;
    background: #ea5330;
    box-sizing: border-box;
  }
}

.list-notification {
  display: block;
  position: absolute;
  z-index: 9999;
  top: 32px;
  left: -30px;
  width: 300px;
  border-radius: 2px;
  box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25),
    0 8px 10px rgba(136, 136, 136, 0.25);
  color: #000000;
  background: #ffffff;

  @include respond-up(md) {
    left: auto;
    right: -36px;
  }
  &:before {
    content: "";
    display: block;
    position: absolute;
    top: -6px;
    left: 31px;
    width: 14px;
    height: 14px;
    border-radius: 2px;
    transform: rotate(45deg);
    background: #ffffff;

    @include respond-up(md) {
      left: auto;
      right: 31px;
    }
  }
  &__header {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;
    align-content: flex-start;
    align-items: center;
    padding: 16px 20px 13px;
    border-bottom: 1px solid #cdced0;

    &-title {
      font-weight: bold;
      font-size: 14px;
      line-height: 16px;
      color: #262626;
    }
    &-right {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      justify-content: flex-start;
      align-content: flex-start;
      align-items: center;
      margin-top: -2px;
    }
    &-btn-all {
      font-weight: bold;
      font-size: 10px;
      line-height: 16px;
      text-decoration: underline;
      color: #009ee3;
      cursor: pointer;
    }
    &-settings {
      margin-top: 3px;
      margin-right: 3px;
      margin-left: 33px;
      color: #009ee3;
      cursor: pointer;
    }
  }
  &__list {
    height: 275px;
  }
  &__item {
    display: block;
    position: relative;
    padding: 14px 20px 20px;

    &:after {
      content: "";
      display: block;
      position: absolute;
      left: 20px;
      right: 20px;
      bottom: 0;
      height: 1px;
      background-color: #cdced0;
    }
    &:last-of-type {
      &:after {
        display: none;
      }
    }
    &-date {
      display: inline-block;
      vertical-align: middle;
      font-weight: bold;
      font-size: 10px;
      line-height: 16px;
      color: #a7a7a7;
    }
    &-title {
      display: block;
      margin-top: 4px;
      font-size: 11px;
      line-height: 16px;
    }
    &-label {
      display: inline-block;
      vertical-align: middle;
      margin-left: 8px;
      padding: 5px 6px;
      background: #005197;
      border-radius: 2px;
      font-weight: 500;
      font-size: 7px;
      line-height: 1;
      text-transform: uppercase;
      text-align: center;
      color: #ffffff;
    }
    &.new {
      background-color: #eff8ff;
    }
  }
}
</style>

<style lang="scss">
.list-notification {
  &__item {
    &-title {
      .link {
        text-decoration: none;
        cursor: pointer;
        color: #009ee3;
      }
    }
  }
}
</style>
